"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListLevelTemplateCodeHistoryItem = exports.ListLevelSuppressRestartHistoryItem = exports.ListLevelSuppressBulletResizeHistoryItem = exports.ListLevelSeparatorHistoryItem = exports.ListLevelRelativeRestartLevelHistoryItem = exports.ListLevelOriginalLeftIndentHistoryItem = exports.ListLevelLegacySpaceHistoryItem = exports.ListLevelLegacyIndentHistoryItem = exports.ListLevelLegacyHistoryItem = exports.ListLevelFormatHistoryItem = exports.ListLevelDisplayFormatStringHistoryItem = exports.ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem = exports.ListLevelAlignmentHistoryItem = exports.ListLevelStartHistoryItem = exports.ListLevelPropertiesHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var errors_1 = require("@devexpress/utils/lib/errors");
var history_item_1 = require("../base/history-item");
var ListLevelPropertiesHistoryItemBase = (function (_super) {
    tslib_1.__extends(ListLevelPropertiesHistoryItemBase, _super);
    function ListLevelPropertiesHistoryItemBase(modelManipulator, isAbstractList, listIndex, levelIndex, newValue) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.newValue = newValue;
        _this.isAbstractList = isAbstractList;
        _this.listIndex = listIndex;
        _this.levelIndex = levelIndex;
        return _this;
    }
    ListLevelPropertiesHistoryItemBase.prototype.redo = function () {
        this.oldState = this.getManipulator().setValue(this.modelManipulator.model, this.isAbstractList, this.listIndex, this.levelIndex, this.newValue);
    };
    ListLevelPropertiesHistoryItemBase.prototype.undo = function () {
        this.getManipulator().restoreValue(this.modelManipulator.model, this.oldState);
    };
    ListLevelPropertiesHistoryItemBase.prototype.getManipulator = function () {
        throw new Error(errors_1.Errors.NotImplemented);
    };
    return ListLevelPropertiesHistoryItemBase;
}(history_item_1.HistoryItem));
exports.ListLevelPropertiesHistoryItemBase = ListLevelPropertiesHistoryItemBase;
var ListLevelStartHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelStartHistoryItem, _super);
    function ListLevelStartHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelStartHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.start;
    };
    return ListLevelStartHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelStartHistoryItem = ListLevelStartHistoryItem;
var ListLevelAlignmentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelAlignmentHistoryItem, _super);
    function ListLevelAlignmentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelAlignmentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.alignment;
    };
    return ListLevelAlignmentHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelAlignmentHistoryItem = ListLevelAlignmentHistoryItem;
var ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem, _super);
    function ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.convertPreviousLevelNumberingToDecimal;
    };
    return ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem = ListLevelConvertPreviousLevelNumberingToDecimalHistoryItem;
var ListLevelDisplayFormatStringHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelDisplayFormatStringHistoryItem, _super);
    function ListLevelDisplayFormatStringHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelDisplayFormatStringHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.displayFormatString;
    };
    return ListLevelDisplayFormatStringHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelDisplayFormatStringHistoryItem = ListLevelDisplayFormatStringHistoryItem;
var ListLevelFormatHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelFormatHistoryItem, _super);
    function ListLevelFormatHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelFormatHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.format;
    };
    return ListLevelFormatHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelFormatHistoryItem = ListLevelFormatHistoryItem;
var ListLevelLegacyHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelLegacyHistoryItem, _super);
    function ListLevelLegacyHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelLegacyHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.legacy;
    };
    return ListLevelLegacyHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelLegacyHistoryItem = ListLevelLegacyHistoryItem;
var ListLevelLegacyIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelLegacyIndentHistoryItem, _super);
    function ListLevelLegacyIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelLegacyIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.legacyIndent;
    };
    return ListLevelLegacyIndentHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelLegacyIndentHistoryItem = ListLevelLegacyIndentHistoryItem;
var ListLevelLegacySpaceHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelLegacySpaceHistoryItem, _super);
    function ListLevelLegacySpaceHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelLegacySpaceHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.legacySpace;
    };
    return ListLevelLegacySpaceHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelLegacySpaceHistoryItem = ListLevelLegacySpaceHistoryItem;
var ListLevelOriginalLeftIndentHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelOriginalLeftIndentHistoryItem, _super);
    function ListLevelOriginalLeftIndentHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelOriginalLeftIndentHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.originalLeftIndent;
    };
    return ListLevelOriginalLeftIndentHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelOriginalLeftIndentHistoryItem = ListLevelOriginalLeftIndentHistoryItem;
var ListLevelRelativeRestartLevelHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelRelativeRestartLevelHistoryItem, _super);
    function ListLevelRelativeRestartLevelHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelRelativeRestartLevelHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.relativeRestartLevel;
    };
    return ListLevelRelativeRestartLevelHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelRelativeRestartLevelHistoryItem = ListLevelRelativeRestartLevelHistoryItem;
var ListLevelSeparatorHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelSeparatorHistoryItem, _super);
    function ListLevelSeparatorHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelSeparatorHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.separator;
    };
    return ListLevelSeparatorHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelSeparatorHistoryItem = ListLevelSeparatorHistoryItem;
var ListLevelSuppressBulletResizeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelSuppressBulletResizeHistoryItem, _super);
    function ListLevelSuppressBulletResizeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelSuppressBulletResizeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.suppressBulletResize;
    };
    return ListLevelSuppressBulletResizeHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelSuppressBulletResizeHistoryItem = ListLevelSuppressBulletResizeHistoryItem;
var ListLevelSuppressRestartHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelSuppressRestartHistoryItem, _super);
    function ListLevelSuppressRestartHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelSuppressRestartHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.suppressRestart;
    };
    return ListLevelSuppressRestartHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelSuppressRestartHistoryItem = ListLevelSuppressRestartHistoryItem;
var ListLevelTemplateCodeHistoryItem = (function (_super) {
    tslib_1.__extends(ListLevelTemplateCodeHistoryItem, _super);
    function ListLevelTemplateCodeHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ListLevelTemplateCodeHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.numberingList.listLevelProperties.templateCode;
    };
    return ListLevelTemplateCodeHistoryItem;
}(ListLevelPropertiesHistoryItemBase));
exports.ListLevelTemplateCodeHistoryItem = ListLevelTemplateCodeHistoryItem;
